import { render } from "./ViewBlog.vue?vue&type=template&id=66b0118a&scoped=true"
import script from "./ViewBlog.vue?vue&type=script&lang=js"
export * from "./ViewBlog.vue?vue&type=script&lang=js"

import "./ViewBlog.vue?vue&type=style&index=0&id=66b0118a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b0118a"]])

export default __exports__